import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import TransactionTable from './TransactionTable';
const Transaction = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Transaction' parent='Transaction'  />
      <Container fluid={true}>
        <Row>
          <TransactionTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default Transaction;
